// API status code Constants
export const NOT_FOUND = 400;
export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const SUCCESSFUL = 200;
export const CREATED = 201;

// Camera mode constants
export const FACING_MODE_USER = 'user';
export const FACING_MODE_ENVIRONMENT = 'environment';

// Practices Filteration Constants
export const FILTER_CONSTANTS = ['Urgent', 'Routine', 'Manual', 'eOrder'];

//Sort By Constants
export const SORT_TYPES = [
  { name: 'Clinic Name', value: 'name' },
  { name: 'No. of Eorders', value: 'eorders' },
  { name: 'Urgent Orders', value: 'urgent_orders' },
];

// Pickup Status Constants
export const PICKUP_STATUSES = ['Assigned', 'En-route'];

// Record Statuses
export const RECORDS_STATUS = [
  {
    id: 1,
    title: 'No Route Assigned',
    description: 'Please wait for your fleet manager to assign you a route.',
  },
  {
    id: 2,
    title: 'No Orders Available',
    description:
      'Please wait for your fleet manager to assign your new clinic orders.',
  },
  {
    id: 3,
    title: 'No Collected Orders',
    description:
      'Please collect orders from pickup tab to see collected orders here.',
  },
  {
    id: 4,
    title: 'No Delivered Orders',
    description:
      'Orders will appear here when you deliver the collected orders to the labs.',
  },
  {
    id: 5,
    title: 'No Order History Yet',
    description:
      'Please collect orders from the logistics to see your orders history here.',
  },
  {
    id: 6,
    title: 'No Results Found',
    description: 'Please wait for your fleet manager to assign you a route.',
  },
];
